import * as React from 'react';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperArrow, CaseStudySlide } from './caseStudyParts';
export function CaseStudies(_a) {
    var items = _a.items;
    var _b = React.useState(0), activeIndex = _b[0], updateIndex = _b[1];
    var breakpoints = {
        0: {
            slidesPerView: 1
        },
        600: {
            slidesPerView: 1
        },
        900: {
            slidesPerView: 2
        },
        1200: {
            slidesPerView: 3
        }
    };
    return (React.createElement("div", { className: 'case-study-container' },
        React.createElement("div", { className: 'case-study-slideshow' },
            React.createElement(Swiper, { slidesPerView: 4, spaceBetween: 20, onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); }, breakpoints: breakpoints, loop: items.caseStudyItems.length > 1, autoHeight: true, initialSlide: 0 },
                items.caseStudyItems.map(function (item, index) {
                    return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                        React.createElement(CaseStudySlide, { item: item, translations: items.caseStudyTranslations, activeIndex: activeIndex }));
                }),
                items.caseStudyItems.length > 1 &&
                    React.createElement("div", { className: 'empori-slideshow-navigation element-flex' },
                        React.createElement(SwiperArrow, { activeIndex: activeIndex, totalSlides: items.caseStudyItems.length, direction: 'left' }),
                        React.createElement(SwiperArrow, { activeIndex: activeIndex, totalSlides: items.caseStudyItems.length, direction: 'right' }))))));
}
export function CaseStudiesList(_a) {
    var items = _a.items;
    var _b = useState(4), visibleItems = _b[0], setVisibleItems = _b[1];
    var generateUniqueId = function (prefix) {
        return "".concat(prefix, "_").concat(Date.now(), "_").concat(Math.floor(Math.random() * 1000));
    };
    var uniqueButtonId = generateUniqueId('button');
    var handleLoadMoreClick = function () {
        setVisibleItems(function (prevVisibleItems) { return prevVisibleItems + 4; });
    };
    useEffect(function () {
        var loadMoreBtn = document.getElementById(uniqueButtonId);
        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', handleLoadMoreClick);
        }
        return function () {
            if (loadMoreBtn) {
                loadMoreBtn.removeEventListener('click', handleLoadMoreClick);
            }
        };
    }, []);
    return (React.createElement("div", { className: "case-studies-list element-flex results" },
        items.caseStudyItems.slice(0, visibleItems).map(function (caseStudy, index) { return (React.createElement("div", { key: index, className: "case-study-list-item element-flex row" },
            React.createElement("div", { className: "basic-grid-image" }, caseStudy.imgPathList
                ? React.createElement("img", { src: caseStudy.imgPathList, width: 1280, height: 720, loading: 'lazy' })
                : React.createElement("i", { className: "fa-regular fa-newspaper" })),
            React.createElement("div", { className: "basic-grid-info" },
                React.createElement("h5", { className: "bullet-subheader" }, caseStudy.company),
                React.createElement("h3", { className: "basic-grid-title" }, caseStudy.title),
                React.createElement("p", null, caseStudy.description),
                React.createElement("a", { href: caseStudy.linkUrl },
                    React.createElement("span", { className: "text-like", title: caseStudy.title }, items.caseStudyTranslations.readMoreLabel))))); }),
        visibleItems < items.caseStudyItems.length && (React.createElement("button", { id: uniqueButtonId }, items.caseStudyTranslations.loadMoreLabel))));
}
